// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.RentCreditReportGetPaymentReportHistoryHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  RentCreditReportPaymentHistoryWebApiRequestDto,
  RentCreditReportWebApiPaymentReportHistoryResponseDto,
} from '../..';

export const RentCreditReportGetPaymentReportHistoryHandler_getPaymentReportHistory_Path =
  '/api/web/v1/rentCreditReport/getPaymentReportHistory';

/**
 * Get Payment Report History
 */
export const RentCreditReportGetPaymentReportHistoryHandler_getPaymentReportHistory = (
  postData: RentCreditReportPaymentHistoryWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    RentCreditReportPaymentHistoryWebApiRequestDto,
    RentCreditReportWebApiPaymentReportHistoryResponseDto
  >(
    {
      endpoint: RentCreditReportGetPaymentReportHistoryHandler_getPaymentReportHistory_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
